import { render, staticRenderFns } from "./courseLeadersFiltersList.vue?vue&type=template&id=da1cdfb8&scoped=true&lang=pug&"
import script from "./courseLeadersFiltersList.vue?vue&type=script&lang=js&"
export * from "./courseLeadersFiltersList.vue?vue&type=script&lang=js&"
import style0 from "./courseLeadersFiltersList.vue?vue&type=style&index=0&id=da1cdfb8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "da1cdfb8",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VSelect } from 'vuetify/lib/components/VSelect';
installComponents(component, {VSelect})
